import { useMemo } from 'react';
import * as analytics from '@adsk/acs-web-analytics';
import { useCurrentAccountId, useCurrentProjectId, useUser } from '@adsk/alloy-provider';

import { getRegion } from '@adsk/acs-sc-web-platform-api';

const useAnalytics = () => {
  const user = useUser();
  const region = getRegion();
  const projectId = useCurrentProjectId();
  const accountId = useCurrentAccountId();
  const analyticsId = user?.user?.analyticsId;

  useMemo(() => {
    if (region && projectId && accountId) {
      const analyticsBaseProperties = {
        data_center: region,
        project_id: projectId,
        account_id: accountId,
        screen_height: window.screen.height,
        screen_width: window.screen.width,
      };

      analytics.setBaseProperties(analyticsBaseProperties);
    }
  }, [region, projectId, accountId, analyticsId]);

  if (!analyticsId) {
    return { trackEvent: () => undefined };
  }

  return { trackEvent: analytics.track, ready: true };
};
export default useAnalytics;
